import React from "react";

const PaymentLinkIcon = (props: any) => {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M2.725 10a4.55 4.55 0 0 1-1.058-2.917A4.597 4.597 0 0 1 6.25 2.5h4.166C12.933 2.5 15 4.567 15 7.083a4.597 4.597 0 0 1-4.584 4.584H8.333"
      />
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M17.275 9.999a4.55 4.55 0 0 1 1.058 2.916A4.597 4.597 0 0 1 13.75 17.5H9.583C7.067 17.499 5 15.432 5 12.915a4.597 4.597 0 0 1 4.583-4.583h2.084"
      />
    </svg>
  );
};

export default PaymentLinkIcon;
